import React, { useState } from 'react';
import { array, object,string } from 'prop-types';
import Hotels from './Hotels';
import Locations from './Locations';
import Keywords from "./Keywords";

function FilteringDesktop({ filtered, tagged, theme,searchKey ,allPlaces}) {
  const [hasHotels, setHasHotels] = useState(true);

  return (
    <div className="grid-x align-center">
      <div className="cell large-3 filtered-locations">
        <h2 className="filtered-title">Locations</h2>
        <div className="find-a-hotel-suggestions">
          <Locations  theme={theme} searchKey={searchKey} allPlaces={allPlaces}/>
        </div>
      </div>
      {hasHotels ? (
        <div className="cell large-4 filtered-hotels">
          <h2 className="filtered-title">Hotels</h2>
          <div className="find-a-hotel-suggestions">
            <Hotels filtered={filtered} setHasHotels={setHasHotels} />
          </div>
        </div>
      ) : <div className="cell large-4 small-6 filtered-hotels" />}
       <div className="cell large-3 filtered-keywords">
        <h2 className="filtered-title">Keywords</h2>
        <div className="find-a-hotel-suggestions">
          <Keywords filtered={tagged} />
        </div>
      </div>
    </div>
  );
}

FilteringDesktop.propTypes = {
  filtered: array.isRequired,
  tagged: array.isRequired,
  theme: object,
    searchKey:string,
    allPlaces:object
};

export default FilteringDesktop;
